<template>
  <OfferCard class="FgtsOfferCard" @click="$emit('action-forward-click')">
    <OfferCardBrand
      :icon-name="(partner || '').toLowerCase()"
      :artwork="false"
      @click="$emit('brand-click')"
    />
    <OfferCardContent>
      <OfferCardLeading>
        <OfferCardLeadingTitle>
          {{ formatMinMax(minAmount, maxAmount) }}
        </OfferCardLeadingTitle>
        <OfferCardLeadingCaption>Descontado do FGTS</OfferCardLeadingCaption>
      </OfferCardLeading>
      <OfferCardAction type="ghost" @click="$emit('offer-conditions-click')">
        Ver mais
      </OfferCardAction>
    </OfferCardContent>
    <OfferCardBadge>{{ cptdInterestRate }}%</OfferCardBadge>
    <OfferCardActionForward @click="$emit('action-forward-click')" />
  </OfferCard>
</template>

<script>
import OfferCard from '~/aasgard/components/cards/offer-card/OfferCard.vue'
import OfferCardBrand from '~/aasgard/components/cards/offer-card/OfferCardBrand.vue'
import OfferCardContent from '~/aasgard/components/cards/offer-card/OfferCardContent.vue'
import OfferCardLeading from '~/aasgard/components/cards/offer-card/OfferCardLeading.vue'
import OfferCardLeadingTitle from '~/aasgard/components/cards/offer-card/OfferCardLeadingTitle.vue'
import OfferCardLeadingCaption from '~/aasgard/components/cards/offer-card/OfferCardLeadingCaption.vue'
import OfferCardAction from '~/aasgard/components/cards/offer-card/OfferCardAction.vue'
import OfferCardBadge from '~/aasgard/components/cards/offer-card/OfferCardBadge.vue'
import OfferCardActionForward from '~/aasgard/components/cards/offer-card/OfferCardActionForward.vue'
import { parseToBRL } from '~/helpers/currency'

export default {
  name: 'FgtsOfferCard',
  components: {
    OfferCardActionForward,
    OfferCardBadge,
    OfferCardAction,
    OfferCardLeadingTitle,
    OfferCardLeading,
    OfferCardContent,
    OfferCardBrand,
    OfferCard,
    OfferCardLeadingCaption,
  },
  props: {
    partner: {
      type: String,
      required: true,
    },
    minAmount: {
      type: Number,
      required: true,
    },
    maxAmount: {
      type: Number,
      required: true,
    },
    interestRate: {
      type: Number,
      required: true,
    },
  },
  emits: ['action-forward-click', 'brand-click', 'offer-conditions-click'],
  computed: {
    cptdInterestRate() {
      return (this.interestRate ?? 0).toFixed(2)
    },
  },
  methods: {
    formatMinMax(min, max) {
      function formatValue(value) {
        if (value >= 1000000) {
          const parsed = parseToBRL(value / 1000000, {
            minimumFractionDigits: 0,
          })
          return `${parsed} mi` // Format millions
        }
        if (value >= 1000 && value < 1000000) {
          const parsed = parseToBRL(value / 1000, {
            minimumFractionDigits: 0,
          })
          return `${parsed} mil` // Format thousands
        }
        return parseToBRL(value, { minimumFractionDigits: 0 })
      }

      const formattedMin = formatValue(min)
      const formattedMax = formatValue(max)

      return `${formattedMin} a ${formattedMax}`
    },
  },
}
</script>

<style lang="scss"></style>
